module.exports = __webpack_public_path__ + "static/img/8818f52f-9ac5-4a30-b824-9135a9646063.6fe1f0fc.png";